var map = {
	"./Neddie-Screen-1.png": 79,
	"./Neddie-Screen-2.png": 80,
	"./Neddie-Screen-3.png": 81,
	"./Neddie-Screen-4.png": 82,
	"./Neddie-Screen-5.png": 83,
	"./Neddie-Screen-6.png": 84,
	"./Neddie-Screen-7.png": 85
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78;